import { Component, OnInit } from '@angular/core';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SearchService } from 'src/app/Services/search.service';
import { PopupComponent } from '../../popup/popup.component';
import { MatDialog } from '@angular/material';
declare var $: any;
@Component({
  selector: 'app-pid-status',
  templateUrl: './pid-status.component.html',
  styleUrls: ['./pid-status.component.css']
})
export class PIDStatusComponent implements OnInit {
  subscription: Subscription;
  searchPIDAdapter: any;
  PIDSearchColumns: any[];
  searchPIDSource: any;
  constructor(private httpRequestService: HttpRequestService,
    private searchService: SearchService,
    public dialog: MatDialog,
    private router: Router, private property: PropertiesService) {
      this.subscription = searchService.searchRefreshEvt$.subscribe(() => {
        this.getGridData();
      });
     }
  ngOnInit() {
    this.gridInint();
    this.getGridData();
  }
  ngAfterViewInit(): void {
    this.gridInint();
    this.getGridData();
  }
  gridInint(){
    var compScope = this;
    this.PIDSearchColumns =
    [
      {
        text: 'S.No', width: '10%', sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
          return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
        }
      },
      { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
      { text: 'Project Name', datafield: 'ProjectName', width: '30%' },
      { text: 'Project Code', datafield: 'ProjectCode', width: '10%' },
      { text: 'Project Type', datafield: 'ItemDescrip', width: '20%' },
      { text: 'Client Name', datafield: 'ClientName', width: '15%' },
      {
        text: 'Approve PID', width: '15%', datafield: 'Approve PID', columntype: 'custom',
        createeditor: (row: number, value: any, editor: any): void => {
          var textBox = $("<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Approve </button>").appendTo(editor);
          $(textBox).click(function () {
            setTimeout(function () {
              $('#searchPID').jqxGrid('selectrow', row);
              compScope.ApprovePID(row);
            }, 0);
          })
        },
        cellsrenderer: function (row) {
          return "<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Approve </button>";
        },
        buttonclick: function (row) {
          $('#searchPID').jqxGrid('selectrow', row);
          compScope.ApprovePID(row);
        },
      },
      {
        text: 'Reject PID', width: '15%', datafield: 'Reject PID', columntype: 'custom',
        createeditor: (row: number, value: any, editor: any): void => {
          var textBox = $("<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Approve </button>").appendTo(editor);
          $(textBox).click(function () {
            setTimeout(function () {
              $('#searchPID').jqxGrid('selectrow', row);
              compScope.RejectPID(row);
            }, 0);
          })
        },
        cellsrenderer: function (row) {
          return "<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Approve </button>";
        },
        buttonclick: function (row) {
          $('#searchPID').jqxGrid('selectrow', row);
          compScope.RejectPID(row);
        },
      },
    ];
  this.searchPIDSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'TransID', type: 'int' },
        { name: 'ProjectName', type: 'string' },
        { name: 'ProjectCode', type: 'string' },
        { name: 'ItemDescrip', type: 'string' },
        { name: 'ClientName', type: 'string' },
      ],
      id: 'transid',
      localdata: ''
    };
  }
  ApprovePID(row){
    let PIDData =  $(".searchPID").jqxGrid('getrowdata',row);
    let TransID = PIDData.TransID;
    if(TransID){
      const dialogRef = this.dialog.open(PopupComponent, {
        width: '99%',
        data: { rptId: 1, rptSPName: '' }
        // , disableClose: true
      });
    }
  }
  RejectPID(row){

  }
  RowclickPIDSearch(event: any): void {
    var args = event.args;
    var selectedRowIndex = args.rowindex;
    // this.searchItem.emit();
    args.row.bounddata.timestamp = new Date().getTime();
    console.log(args);
    this.router.navigate(['home/PID'], { queryParams: args.row.bounddata });

  }
  getGridData() {
    this.getData().then((list: any) => {
      this.searchPIDSource.localdata = list.result;
      console.log(list.result);
      this.searchPIDAdapter = new jqx.dataAdapter(this.searchPIDSource);
      $(".searchPID").jqxGrid('updatebounddata');
    });

  }
  getData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/pid/all?branchCode=1")
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

}